$(document).ready(function() {
    $('.iban').mask(
        'SS00 SSSS 0000 0000 00', {
            placeholder: "____ ____ ____ ____ __",
            onKeyPress: function (value, event) {
                event.currentTarget.value = value.toUpperCase();
            },
    });
});
